export default __webpack_public_path__ + "static/media/Backend.8a259e87.svg";